import { render } from "./RevivalPopup.vue?vue&type=template&id=6b376222&scoped=true"
import script from "./RevivalPopup.vue?vue&type=script&lang=js"
export * from "./RevivalPopup.vue?vue&type=script&lang=js"

import "./RevivalPopup.vue?vue&type=style&index=0&id=6b376222&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b376222"]])

export default __exports__